import React, { useState } from 'react';
import PhoneMockup from '../components/PhoneMockup.jsx';
import {
  BRAND, HERO, STATS, FEATURES, STORE_TYPES,
  HOW_IT_WORKS, TESTIMONIALS, PRICING_PLANS, FAQ,
} from '../mock/mockData.js';

function StoreBtns() {
  return (
    <div style={{ display:'flex', gap:12, flexWrap:'wrap', width:'100%', maxWidth:'100%' }}>
      {/*<a href={BRAND.appStoreUrl} className="store-btn ios" target="_blank" rel="noopener noreferrer">
        <span className="si">🍎</span>
        <span className="st">
          <span className="sl">Download on the</span>
          <span className="sn">App Store</span>
        </span>
      </a>*/}
      <a href={BRAND.playStoreUrl} className="store-btn and" target="_blank" rel="noopener noreferrer" 
        style={{ backgroundImage: 'url(/assets/google-play-badge-270x80.png)', backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: 'clamp(160px, 90%, 180px)', height: '54px', display: 'flex', alignItems: 'center', justifyContent: 'center', textIndent: '-9999px', overflow: 'hidden' }}>
        <span className="si">▶</span>
        <span className="st">
          <span className="sl"></span>
          <span className="sn"></span>
        </span>
      </a>
    </div>
  );
}

export default function Home() {
  const [faq, setFaq] = useState(null);

  return (
    <>
      {/* ── Hero ─────────────────────────────────────────────── */}
      <section className="hero-bg">
        <div className="hero-inner">
          <div className="ctr">
            <div style={{ display:'grid', gridTemplateColumns:'1fr auto', gap:'3rem', alignItems:'center', '@media (max-width: 768px)': { gridTemplateColumns:'1fr', gap:'2rem' } }}>
              <div>
                {/* <div className="eyebrow" style={{ background:'rgba(255,255,255,.12)', color:'rgba(255,255,255,.9)' }}>
                  {HERO.eyebrow}
                </div> */}
                <h1 className="display" style={{ color:'white', marginBottom:'1.25rem' }}>
                  {HERO.title}<br/>
                  <span style={{ color:'#F59E0B' }}>{HERO.titleAccent}</span>
                </h1>
                <p style={{ fontSize:'clamp(1rem, 1.1rem, 1.1rem)', color:'rgba(255,255,255,.75)', lineHeight:1.7, maxWidth:500, marginBottom:'2rem' }}>
                  {HERO.subtitle}
                </p>
                <StoreBtns />
                <div style={{ display:'flex', gap:'2.5rem', marginTop:'2.5rem', flexWrap:'wrap' }}>
                  {STATS.map(s => (
                    <div key={s.label}>
                      <div style={{ fontSize:'1.5rem', fontWeight:900, color:'#F59E0B', lineHeight:1 }}>{s.value}</div>
                      <div style={{ fontSize:'.8rem', color:'rgba(255,255,255,.6)', marginTop:2 }}>{s.label}</div>
                    </div>
                  ))}
                </div>
              </div>
              <PhoneMockup />
            </div>
          </div>
        </div>
      </section>

      {/* ── Store type strip ─────────────────────────────────── */}
      <section style={{ background:'white', borderBottom:'1px solid var(--border)', padding:'1.25rem 0' }}>
        <div className="ctr">
          <div style={{ display:'flex', alignItems:'center', gap:'1.5rem', flexWrap:'wrap', justifyContent:'center' }}>
            <span style={{ fontSize:'.75rem', fontWeight:700, color:'var(--text3)', textTransform:'uppercase', letterSpacing:'.08em' }}>Works for</span>
            {STORE_TYPES.map(s => (
              <div key={s.label} style={{ display:'flex', alignItems:'center', gap:5, fontSize:'.9rem', fontWeight:500, color:'var(--text2)' }}>
                <span>{s.icon}</span>{s.label}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Features ─────────────────────────────────────────── */}
      <section className="sec">
        <div className="ctr">
            {/* <div style={{ textAlign:'center', marginBottom:'3rem' }}>
            <span className="eyebrow">Everything you need</span>
            <h2 className="htitle">One app. Complete control.</h2>
            <p className="hsub" style={{ margin:'.75rem auto 0' }}>
              From billing to inventory to payments — TotalPe replaces 5 different tools with one affordable app.
            </p>
          </div> */}
          <div className="g4">
            {FEATURES.map(f => (
              <div key={f.title} className="card">
                <div className="ibox">{f.icon}</div>
                <h3 style={{ fontWeight:700, marginBottom:'.5rem', fontSize:'1rem' }}>{f.title}</h3>
                <p style={{ fontSize:'.9rem', color:'var(--text2)', lineHeight:1.6 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── How it works ─────────────────────────────────────── */}
      <section className="sec sec-alt">
        <div className="ctr">
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'4rem', alignItems:'center', '@media (max-width: 768px)': { gridTemplateColumns:'1fr', gap:'2.5rem' } }}>
            <div>
              <span className="eyebrow">Get started in minutes</span>
              <h2 className="htitle" style={{ marginBottom:'2.5rem' }}>From download to first bill in 5 minutes</h2>
              {HOW_IT_WORKS.map((s, i) => (
                <div key={s.step}>
                  <div className="pstep">
                    <div className="pnum">{s.step}</div>
                    <div>
                      <h4 style={{ fontWeight:700, marginBottom:4, fontSize:'clamp(.95rem, 1rem, 1rem)' }}>{s.title}</h4>
                      <p style={{ fontSize:'clamp(.85rem, .9rem, .9rem)', color:'var(--text2)', lineHeight:1.6 }}>{s.desc}</p>
                    </div>
                  </div>
                  {i < HOW_IT_WORKS.length - 1 && <div className="pcon" />}
                </div>
              ))}
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:'1rem' }}>
              <div className="imgph" style={{ overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', minHeight:'380px' }}>
                <img src="/assets/totalpe-og-1200x630.png" alt="TotalPe" style={{ width:'100%', height:'100%', objectFit:'contain'}}/>
              </div>
              <StoreBtns />
            </div>
          </div>
        </div>
      </section>

      {/* ── Testimonials ─────────────────────────────────────── */}
      <section className="sec">
        <div className="ctr">
          <div style={{ textAlign:'center', marginBottom:'3rem' }}>
            <span className="eyebrow">Merchant stories</span>
            <h2 className="htitle">Loved by hotel and restaurant owners</h2>
          </div>
          <div className="g2">
            {TESTIMONIALS.map(t => (
              <div key={t.name} className="tcard">
                <div className="stars">{'★'.repeat(t.stars)}</div>
                <p className="ttext">{t.text}</p>
                <div className="tauthor">
                  <div className="avatar">{t.avatar}</div>
                  <div>
                    <div style={{ fontWeight:600, fontSize:'.95rem' }}>{t.name}</div>
                    <div style={{ fontSize:'.8rem', color:'var(--text3)' }}>{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Pricing ──────────────────────────────────────────── */}
      <section className="sec sec-alt" id="pricing">
        <div className="ctr">
          {/*<div style={{ textAlign:'center', marginBottom:'3rem' }}>
            <span className="eyebrow">Simple pricing</span>
            <h2 className="htitle">Start free. Scale as you grow.</h2>
            <p className="hsub" style={{ margin:'.75rem auto 0' }}>No setup fees. No hidden charges. Cancel anytime.</p>
          </div>*/}
          <div className="g3">
            {/*PRICING_PLANS.map(p => (
              <div key={p.name} className={'pcrd' + (p.featured ? ' feat' : '')}>
                {p.featured && <div className="pbadge">Most Popular</div>}
                <h3 style={{ fontWeight:800, marginBottom:'.25rem' }}>{p.name}</h3>
                <p style={{ fontSize:'.85rem', color:'var(--text3)', marginBottom:'1rem' }}>{p.desc}</p>
                <div style={{ fontSize:'2.4rem', fontWeight:900, lineHeight:1, marginBottom:'1rem' }}>
                  {p.price === '0' ? 'Free' : '₹' + p.price}
                  <span style={{ fontSize:'1rem', fontWeight:500, color:'var(--text3)' }}>{p.period}</span>
                </div>
                <hr style={{ border:'none', borderTop:'1px solid var(--border)', margin:'1rem 0' }}/>
                <div style={{ marginBottom:'1.5rem' }}>
                  {p.features.map(f => (
                    <div key={f.text} className="prow">
                      <span className={f.ok ? 'pok' : 'pno'}>{f.ok ? '✓' : '–'}</span>
                      <span style={{ opacity: f.ok ? 1 : 0.45 }}>{f.text}</span>
                    </div>
                  ))}
                </div>
                <a href={BRAND.playStoreUrl} className={'btn ' + (p.featured ? 'btn-p' : 'btn-o')}
                  style={{ width:'100%', justifyContent:'center' }}
                  target="_blank" rel="noopener noreferrer">
                  {p.cta}
                </a>
              </div>
            ))*/}
          </div>
        </div>
      </section>

      {/* ── FAQ ──────────────────────────────────────────────── */}
      <section className="sec" id="faq">
        <div className="ctr" style={{ maxWidth:740 }}>
          <div style={{ textAlign:'center', marginBottom:'3rem' }}>
            <span className="eyebrow">Got questions?</span>
            <h2 className="htitle">Frequently asked questions</h2>
          </div>
          {FAQ.map((item, i) => (
            <div key={i} className="faq-item">
              <button className="faq-q" onClick={() => setFaq(faq === i ? null : i)}>
                {item.q}
                <span style={{ color:'var(--vivid)', fontSize:'1.4rem', flexShrink:0, transition:'transform .2s', transform: faq === i ? 'rotate(45deg)' : 'none' }}>+</span>
              </button>
              {faq === i && <p className="faq-a">{item.a}</p>}
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA Banner ───────────────────────────────────────── */}
      <section style={{ background:'linear-gradient(135deg,#1F1535,#5B21B6)', padding:'5rem 0', textAlign:'center' }}>
        <div className="ctr">
          <h2 style={{ color:'white', fontWeight:900, fontSize:'clamp(1.5rem,4vw,2.6rem)', marginBottom:'1rem', lineHeight:1.2 }}>
            Ready to transform your business?
          </h2>
          <p style={{ color:'rgba(255,255,255,.7)', fontSize:'clamp(1rem, 1.05rem, 1.05rem)', marginBottom:'2rem', lineHeight:1.6 }}>
            Download the TotalPe App today..!
          </p>
          <StoreBtns />
        </div>
      </section>
    </>
  );
}